/* Unadvertised Deal: the Web Price explainer everywhere, and on a product page the drawer
 * that asks the worker for the price.
 *
 * Markup: snippets/aps-deal-label.liquid, snippets/aps-deal-drawer.liquid.
 * Worker:  workers/unadvertised-deal. Plan: docs/decisions/2026-09-14-unadvertised-deal.md.
 *
 * THE INVARIANT: the sent panel is shown in exactly one place, the branch where the worker
 * answered ok:true. Nothing on the client may claim a request was sent. The quote drawer
 * learned this the hard way; see docs/decisions/2026-09-04-quote-drawer.md.
 */
(function () {
  if (window.APSDeal) return;
  window.APSDeal = {};

  /* ---- the explainer ------------------------------------------------------
     Click toggles it, anywhere. Hover opens it on a desktop pointer, which is CSS. A card's
     ? sits near the card's links, so the click stops there and goes no further. */
  function closeTips(except) {
    document.querySelectorAll('.aps-deal .wp.is-open').forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var q = w.querySelector('[data-aps-deal-q]');
      if (q) q.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-aps-deal-q]');
    if (q) {
      e.preventDefault();
      e.stopPropagation();
      var w = q.closest('.wp');
      var open = !w.classList.contains('is-open');
      closeTips(w);
      w.classList.toggle('is-open', open);
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('.aps-deal .wp-tip')) closeTips(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTips(null); });

  /* ---- the variant chips --------------------------------------------------
     aps-pdp.js announces every change. Liquid rendered the label and the button hidden when
     the first variant is not eligible but another is; they follow the chips from here. */
  function variants() {
    var el = document.querySelector('[data-aps-variants]');
    try { return JSON.parse(el ? el.textContent : '[]'); } catch (err) { return []; }
  }
  function applyVariant(v) {
    if (!v) return;
    var on = v.deal === true;
    document.querySelectorAll('[data-aps-deal-show]').forEach(function (el) { el.hidden = !on; });
    document.querySelectorAll('[data-aps-deal-hide]').forEach(function (el) { el.hidden = on; });
  }
  document.addEventListener('aps:variant', function (e) { applyVariant(e.detail); });

  /* For the cart drawer, which fills its line from /cart.js and cannot read metafields. */
  window.APSDeal.isEligible = function (variantId) {
    var id = Number(variantId);
    return variants().some(function (v) { return v.id === id && v.deal === true; });
  };

  /* ---- the drawer, only where it was rendered ----------------------------- */
  var root = document.querySelector('[data-aps-deal-root]');
  if (!root) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var scrim = $('.scrim');
  var panel = $('.ddrw');
  var form = $('[data-aps-deal-form]');
  var sent = $('[data-aps-deal-sent]');
  var err = $('[data-aps-deal-err]');
  var errText = $('[data-aps-deal-errtext]');
  var submit = $('[data-aps-deal-submit]');
  var submitLabel = submit.textContent;
  var qtyEl = $('[data-aps-deal-qty]');
  var tsHost = $('[data-aps-deal-turnstile]');
  var endpoint = root.dataset.endpoint;
  var lastFocus = null;
  var prevOverflow = '';

  function current() {
    var idEl = document.querySelector('[data-aps-variant-id]');
    var id = idEl ? Number(idEl.value) : NaN;
    var list = variants();
    return list.filter(function (v) { return v.id === id; })[0] || list.filter(function (v) { return v.deal; })[0] || null;
  }

  function fill() {
    var v = current();
    if (!v) return null;
    var title = document.querySelector('h1.pt');
    $('[data-aps-deal-title]').textContent = title ? title.textContent.trim() : $('[data-aps-deal-title]').textContent;
    $('[data-aps-deal-price]').textContent = v.money;
    var img = $('[data-aps-deal-img]');
    if (v.image && img) { img.src = v.image; img.hidden = false; }
    var buyQty = document.querySelector('[data-aps-qty-value]');
    qtyEl.value = Math.max(1, parseInt(buyQty && buyQty.value, 10) || 1);
    return v;
  }

  function resetToForm() {
    sent.hidden = true;
    form.hidden = false;
    err.hidden = true;
  }

  function open() {
    var v = fill();
    if (!v || v.deal !== true) return;
    closeTips(null);
    if (!sent.hidden) { form.reset(); resetToForm(); fill(); }
    lastFocus = document.activeElement;
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-open');
    panel.classList.add('is-open');
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    loadTurnstile().catch(function () {});
    var first = form.querySelector('[name="name"]');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    scrim.classList.remove('is-open');
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    document.documentElement.style.overflow = prevOverflow;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-aps-deal-open]');
    if (t) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-aps-deal-close]') && root.contains(e.target)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!panel.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(
      panel.querySelectorAll('button, [href], input, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  root.querySelectorAll('[data-aps-deal-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = (parseInt(qtyEl.value, 10) || 1) + parseInt(b.dataset.apsDealStep, 10);
      qtyEl.value = Math.min(999, Math.max(1, n));
    });
  });

  // A card's explainer link arrives here as #unadvertised-deal.
  if (location.hash === '#unadvertised-deal') setTimeout(open, 300);

  /* ---- Turnstile ----------------------------------------------------------
     Loaded on first open, not on every product page. Rendered once with execution:execute,
     so no challenge runs until the reader presses send. */
  var tsLoad = null;
  var tsWidget = null;
  var tsPending = null;
  function loadTurnstile() {
    if (tsLoad) return tsLoad;
    tsLoad = new Promise(function (resolve, reject) {
      window.apsDealTurnstileReady = resolve;
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=apsDealTurnstileReady&render=explicit';
      s.async = true;
      s.onerror = function () { tsLoad = null; reject(new Error('turnstile_load')); };
      document.head.appendChild(s);
    });
    return tsLoad;
  }
  function turnstileToken() {
    return loadTurnstile().then(function () {
      return new Promise(function (resolve, reject) {
        tsPending = { resolve: resolve, reject: reject };
        var settle = function (fn, arg) { if (tsPending) { var p = tsPending; tsPending = null; p[fn](arg); } };
        if (tsWidget === null) {
          tsWidget = window.turnstile.render(tsHost, {
            sitekey: root.dataset.sitekey,
            execution: 'execute',
            appearance: 'interaction-only',
            callback: function (t) { settle('resolve', t); },
            'error-callback': function () { settle('reject', new Error('turnstile')); return true; },
            'expired-callback': function () { settle('reject', new Error('turnstile_expired')); },
          });
        } else {
          window.turnstile.reset(tsWidget);
        }
        window.turnstile.execute(tsWidget);
        setTimeout(function () { settle('reject', new Error('turnstile_timeout')); }, 25000);
      });
    });
  }

  /* ---- send ---------------------------------------------------------------- */
  function showError(kind) {
    errText.textContent = err.dataset[kind] || err.dataset.generic;
    err.hidden = false;
    err.scrollIntoView({ block: 'nearest' });
  }

  var EMAIL_RE = /^[^\s@]{1,64}@[^\s@]{1,190}\.[^\s@]{2,}$/;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err.hidden = true;
    var v = current();
    var data = {
      variantId: v && v.id,
      quantity: Math.min(999, Math.max(1, parseInt(qtyEl.value, 10) || 1)),
      name: form.elements.name.value.trim(),
      email: form.elements.email.value.trim(),
      phone: form.elements.phone.value.trim(),
      notes: form.elements.notes.value.trim(),
      url: root.dataset.productUrl + (v ? '?variant=' + v.id : ''),
    };
    if (!data.name || !EMAIL_RE.test(data.email)) {
      showError('missing');
      (data.name ? form.elements.email : form.elements.name).focus();
      return;
    }
    if (!v) { showError('gone'); return; }

    submit.disabled = true;
    submit.textContent = submit.dataset.sending;

    turnstileToken()
      .then(function (token) {
        data.turnstileToken = token;
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'server_error' }; }); });
      }, function () { return { ok: false, error: 'verification_failed' }; })
      .then(function (res) {
        if (res && res.ok === true) {
          // The one place the sent panel appears.
          var title = $('[data-aps-deal-title]').textContent;
          root.querySelectorAll('[data-aps-deal-sent-item]').forEach(function (b) { b.textContent = data.quantity + ' × ' + title; });
          root.querySelectorAll('[data-aps-deal-sent-email]').forEach(function (b) { b.textContent = data.email; });
          $('[data-aps-deal-sent-auto]').hidden = !!res.review;
          $('[data-aps-deal-sent-review]').hidden = !res.review;
          $('[data-aps-deal-held]').textContent = res.held_until || '';
          $('[data-aps-deal-held-wrap]').hidden = !!res.review || !res.held_until;
          form.hidden = true;
          sent.hidden = false;
          sent.focus({ preventScroll: true });
          if (window.gtag) window.gtag('event', 'unadvertised_deal_request', { item_id: String(data.variantId), quantity: data.quantity, review: !!res.review });
          return;
        }
        var map = { verification_failed: 'verify', rate_limited: 'rate', not_eligible: 'gone', missing_fields: 'missing' };
        showError(map[res && res.error] || 'generic');
      })
      .catch(function () { showError('generic'); })
      .then(function () {
        submit.disabled = false;
        submit.textContent = submitLabel;
      });
  });
})();
